import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService } from '../../../../../config/config.service';
import { MaterialExcluido } from '../../../../../types/MaterialExcluido.type';
import { Page } from '../../../../../types/Page.type';

@Injectable({
  providedIn: 'root'
})
export class MaterialExcluidoService {

  constructor(private httpClient: HttpClient, private configService: ConfigService) { }

  getAll(page: number, size: number, sortField: string, sortDirection: string) {
    return this.httpClient.get<Page<MaterialExcluido>>(
      `${this.configService.getApiUrlRoot()}/transfinsumos/materiais-excluidos?page=${page}&size=${size}&sort=${sortField},${sortDirection}`
    );
  }

  post(body: { codigoMaterial: string }) {
    return this.httpClient.post<MaterialExcluido>(
      `${this.configService.getApiUrlRoot()}/transfinsumos/materiais-excluidos`, body
    );
  }

  put(publicId: string, body: { codigoMaterial: string }) {
    return this.httpClient.put<MaterialExcluido>(
      `${this.configService.getApiUrlRoot()}/transfinsumos/materiais-excluidos/${publicId}`, body
    );
  }

  alternarStatus(publicId: string) {
    return this.httpClient.patch<MaterialExcluido>(
      `${this.configService.getApiUrlRoot()}/transfinsumos/materiais-excluidos/${publicId}/status`, null
    );
  }

  delete(publicId: string) {
    return this.httpClient.delete(
      `${this.configService.getApiUrlRoot()}/transfinsumos/materiais-excluidos/${publicId}`
    );
  }
}
